import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  site: {
    logo: {
      src: { light: "/logo-light.svg", dark: "/logo-dark.svg" },
      alt: "ContactBased",
      width: "130px",
    },
  },
  metadata: {
    title: "ContactBased",
    description: "Data-driven precision. Intent data APIs for discovering high-intent companies.",
    favicon: "/favicon.ico",
  },
  navigation: [
    {
      type: "category",
      label: "Documentation",
      items: [
        {
          type: "category",
          label: "Getting Started",
          icon: "sparkles",
          items: [
            { type: "doc", file: "/introduction", path: "/" },
            { type: "doc", file: "/webhooks", path: "/webhooks" },
            {
              type: "link",
              icon: "folder-cog",
              badge: {
                label: "New",
                color: "purple",
              },
              label: "API Reference",
              to: "/api",
            },
          ],
        },
      ],
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
    },
  ],
  apis: [
    {
      type: "file",
      input: "./public/apis/openapi.json",
      path: "/api",
      options: {
        showInfoPage: false,
      },
    },
  ],
};

export default config;
